import { useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";
import { useProjectId } from "hooks/useProjectId";
import ForumPostService from "services/projects/ForumPostService";
import PostCard from "./PostCard";
import classes from "./classes.module.scss";

const forumPostService = container.resolve(ForumPostService);

export default function Forum() {
	const { posts } = useGeneralPosts();

	return (
		<div className={classes["root"]}>
			{posts.map((post) => (
				<PostCard key={post.id} post={post} />
			))}
		</div>
	);
}

const useGeneralPosts = () => {
	const { projectId } = useProjectId();
	const [posts, setPosts] = useState<ForumPostResponseResource[]>([]);

	const fetchPosts = useCallback(() => {
		return forumPostService
			.getGeneralPosts(projectId)
			.then(setPosts)
			.catch((error) => {
				console.error(error);
				setPosts([]);
			});
	}, [projectId]);

	useEffect(() => {
		fetchPosts();
	}, [fetchPosts]);

	return { posts };
};
